import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';

import { saveShowOnlyActiveMachines } from 'Courses/data';
import { useAppDispatch } from 'Store';
import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

import type { ISaveShowOnlyActiveMachinesRequest } from '@libs/models';
import { VisibilityIcon } from '@libs/shared/ui/icons';

import { StyledCard } from './live-preview-card/live-preview-card.styles';

const ContentWrapper = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  gap: ${Spacing.medium};
  justify-content: center;
  padding: ${Spacing.medium};
  border-radius: 8px 8px 0 0;
`;

const MessageText = styled(Typography)`
  text-align: center;
  font-style: italic;
  color: ${Colors.darkGrey};
`;

const ShowInactiveUsersButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${Spacing.small};
`;

type Props = {
  courseId: string;
  inactiveUsersCount: number;
};

export const InactiveUsersCard = ({ courseId, inactiveUsersCount }: Readonly<Props>) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleShowInactiveUsers = () => {
    dispatch(
      saveShowOnlyActiveMachines({
        courseId,
        showOnlyActiveMachines: false
      } as ISaveShowOnlyActiveMachinesRequest)
    );
  };

  return (
    <StyledCard>
      <ContentWrapper>
        <MessageText variant="body2">
          {t('coursePanel.inactiveUsersMessage', {
            count: inactiveUsersCount,
            defaultValue: `W kursie jest jeszcze ${inactiveUsersCount} nieaktywnych użytkowników.`
          })}
        </MessageText>
        <ShowInactiveUsersButton
          variant="outlined"
          onClick={handleShowInactiveUsers}
          startIcon={<VisibilityIcon />}
        >
          {t('coursePanel.showInactiveUsers', { defaultValue: 'Pokaż' })}
        </ShowInactiveUsersButton>
      </ContentWrapper>
    </StyledCard>
  );
};
